export const Translations_ES = {
	footer: {
		join: "Unirse a la discusión ahora. No es necesaria la aplicación ni acceder a tu cuenta.",
		climate: "Discusión positiva sobre el clima.",
		tree: "Hemos plantado este árbol.",
		start: "Comenzar una video discusión gratis.",
	},
};
